module.exports = __webpack_public_path__ + "img/xsyb1.5e004b43.jpg";